module.exports = __webpack_public_path__ + "img/reply_hover.f8515c5c.svg";